import { DownloadOutlined } from '@ant-design/icons';
import { Card } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/macro';

/** Point these at your listing URLs (or set REACT_APP_CHROME_EXTENSION_URL / REACT_APP_FIREFOX_EXTENSION_URL). */
export const resolveChromeExtensionUrl = () =>
  process.env.REACT_APP_CHROME_EXTENSION_URL ||
  'https://guido-staging.fra1.cdn.digitaloceanspaces.com/extensions/dist.zip';

export const resolveFirefoxExtensionUrl = () =>
  process.env.REACT_APP_FIREFOX_EXTENSION_URL ||
  'https://guido-staging.fra1.cdn.digitaloceanspaces.com/extensions/dist-firefox.zip';

const ExtensionLink = styled.a`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 6px;
  color: inherit;
  text-decoration: none;
  transition: background 0.15s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.thinOrange};
    color: inherit;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.strongBlue};
    outline-offset: 2px;
  }
`;

const LinkMeta = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  flex: 1;
`;

const LinkTitle = styled.span`
  font-weight: 600;
  font-size: 14px;
`;

const LinkHint = styled.span`
  font-size: 12px;
  opacity: 0.55;
`;

const LinksStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const IconImage = styled.img`
  width: 22px;
  height: 22px;
  display: block;
  object-fit: contain;
`;

const IconChrome = () => (
  <IconImage
    src={`${process.env.PUBLIC_URL}/chrome.png`}
    alt=""
    aria-hidden="true"
  />
);

const IconFirefox = () => (
  <IconImage
    src={`${process.env.PUBLIC_URL}/firefox.png`}
    alt=""
    aria-hidden="true"
  />
);

export const BrowserExtensionsDownloadColumn = () => {
  const { t } = useTranslation();

  const chromeHref = resolveChromeExtensionUrl();
  const firefoxHref = resolveFirefoxExtensionUrl();

  return (
    <Card className="gd-card" title={t('downloads:browserExtensions.title')}>
      <LinksStack>
        <ExtensionLink
          href={chromeHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('downloads:browserExtensions.chromeAria')}
        >
          <IconChrome />
          <LinkMeta>
            <LinkTitle>
              {t('downloads:browserExtensions.chromeLabel')}
            </LinkTitle>
            <LinkHint>{t('downloads:browserExtensions.downloadHint')}</LinkHint>
          </LinkMeta>
          <DownloadOutlined style={{ fontSize: 18, opacity: 0.65 }} />
        </ExtensionLink>
        <ExtensionLink
          href={firefoxHref}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('downloads:browserExtensions.firefoxAria')}
        >
          <IconFirefox />
          <LinkMeta>
            <LinkTitle>
              {t('downloads:browserExtensions.firefoxLabel')}
            </LinkTitle>
            <LinkHint>{t('downloads:browserExtensions.downloadHint')}</LinkHint>
          </LinkMeta>
          <DownloadOutlined style={{ fontSize: 18, opacity: 0.65 }} />
        </ExtensionLink>
      </LinksStack>
    </Card>
  );
};
